module.exports = __webpack_public_path__ + "img/banner-about.99cace9a.jpeg";